export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-hammer-line',
      title: '목형 제작',
      description: '포장재 및 제품 생산용 특수목형 제작 전문. 30년 경력의 숙련된 기술진이 정밀하게 제작합니다.',
      features: ['특수목형 제작', '포장재 목형', '제품 생산용 목형', '맞춤 제작']
    },
    {
      icon: 'ri-scissors-cut-line',
      title: '레이저 커팅',
      description: '나무, 아크릴, 가죽, 종이 등 다양한 재료의 정밀 레이저 커팅 서비스를 제공합니다.',
      features: ['청첩장', '팝업카드', '인테리어소품', 'LED 무드등']
    },
    {
      icon: 'ri-edit-box-line',
      title: '레이저 마킹',
      description: '나무, 금속, 가죽, 아크릴 등에 정밀한 각인 서비스를 제공합니다.',
      features: ['명패 제작', '표찰 각인', '우드포토', '맞춤 각인']
    }
  ];

  return (
    <section className="py-20 px-4 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">핵심 서비스</h2>
          <p className="text-lg text-slate-600">재기목형의 전문 서비스를 소개합니다</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-slate-100 hover:border-amber-400 hover:-translate-y-2"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-slate-700 to-slate-900 rounded-lg mb-6 group-hover:from-amber-500 group-hover:to-amber-600 transition-all duration-300">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">{service.title}</h3>
              <p className="text-slate-600 mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-slate-700">
                    <i className="ri-check-line text-amber-500 text-lg"></i>
                    <span className="text-sm">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
